import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyMarketKey,
  ShopifyMarketToReturnPolicyProfileKey,
  ShopifyReturnPolicyProfileToMarketsKey,
  ShopifyReturnPolicyProfileKey,
  ShopifyReturnPolicyProfileToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyReturnPolicyProfileKey,
  "2026-10": {
    name: "Shopify Return Policy Profile",
    graphQLTypename: "ReturnPolicyProfile",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "id" },
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "name" },
        },
      },
      {
        name: "Default",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "default" },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "updatedAt" },
        },
      },
      {
        name: "Edit Rules",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "editRules",
            graphQLSelection: "canAcceptEdits editWindowMinutes",
          },
        },
      },
      {
        name: "Return Rules",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "returnRules",
            graphQLSelection: "canAcceptReturns extendWindowToBusinessDay returnWindowDays returnWindowStartingFrom",
          },
        },
      },
      {
        name: "Markets",
        fieldType: FieldType.HasMany,
        key: ShopifyReturnPolicyProfileToMarketsKey,
        configuration: { relatedModelKey: ShopifyMarketKey, inverseFieldKey: ShopifyMarketToReturnPolicyProfileKey },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyReturnPolicyProfileToShopKey,
        configuration: { relatedModelKey: ShopifyShopKey },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "returnPolicyProfiles",
      filters: {},
    },
  },
};

export const ShopifyReturnPolicyProfile = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
